import React from 'react';

import { Carousel } from 'components/carousel/Carousel';
import { IconsEnum } from 'components/Icons';
import { SportNewsCard } from 'components/sportNews/card';
import { SportNewsProps } from '.';
import { Wrapper } from 'components/wrapper';
import styles from './SportNews.module.scss';
import { isTruthy } from 'utility/functions';

export const SportNews = ({ url, title, news }: SportNewsProps) => {
  if (isTruthy(news.length)) {
    return (
      <Wrapper noPaddingRight noPaddingLeft classNameWrapper={styles.wrapper}>
        <Carousel
          title={title}
          classNameTitle={styles.title}
          url={url}
          cardContainerClassName={styles.cardContainerSportNews}
          iconId={IconsEnum.LINK_EXTERNAL}
          classNameIcon={styles.icon}
        >
          {news!.map((item, index) => (
            <SportNewsCard
              key={`${item.title}_${index}`}
              link={item.link}
              title={item.title}
              preview={item.thumbnail}
              category={item.category}
              description={item.description!}
            />
          ))}
        </Carousel>
      </Wrapper>
    );
  }
  return null;
};
